<template>
    <div class="product-main--buy">
        <div class="cs-qty">
            <input class="cs-qty--field" v-model.number="counter" type="text" min="0">
            <div class="cs-qty--minus" v-on:click="toggle(-1)">-</div>
            <div class="cs-qty--plus" v-on:click="toggle(+1)">+</div>
        </div>
        <div class="product-main--favourite" @click="addToFavorites">
            <template v-if="isFavorite">
                <svg class="svg-sprite-icon svg-sprite-unstyled icon-hearth-fill">
                    <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-hearth-fill"></use>
                </svg>
                <span class="product-main--favourite-text"><span>Remove</span> from wishlist</span>
            </template>
            <template v-else>
                <svg class="svg-sprite-icon svg-sprite-unstyled icon-hearth">
                    <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-hearth"></use>
                </svg>
                <span class="product-main--favourite-text"><span>Add</span> to wishlist</span>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        productId: {
            type: String
        },
    },
    data: () => ({
       counter: 1,
       isFavorite: false
    }),
    methods: {
        addToFavorites() {
            let products = JSON.parse(localStorage.getItem("products"));
            if(products !== null){
                if (products.hasOwnProperty(this.productId)) {
                    delete products[this.productId];
                }else {
                    products[this.productId] = this.counter;
                }
                localStorage.setItem("products", JSON.stringify(products));
            } else{
                products = {
                    [this.productId]: this.counter
                }
                localStorage.setItem("products", JSON.stringify(products));
            }
            this.getFavorites();
        },
        toggle(value) {
            this.counter += value;
            if(this.counter < 1) this.counter = 1
        },
        getFavorites() {
            let products = JSON.parse(localStorage.getItem("products"));
            let favorites_storage = Object.assign({}, products);
            let favorites_keys = Object.keys(favorites_storage);
            if(this.productId in products) {
                this.isFavorite = true
                this.counter = products[this.productId]
            }else {
                this.isFavorite = false;
            }
        },
    },
    mounted() {
        this.getFavorites();
    },
}
</script>